import React from "react";
import "./ActionButton.css";

interface ActionButtonProps {
  text: string;
  color: string;
  hoverColor: string;
  onClick?: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  text,
  color,
  hoverColor,
  onClick,
}) => {
  return (
    <button
      className="action-button"
      style={
        {
          "--button-color": color,
          "--button-hover-color": hoverColor,
        } as React.CSSProperties
      }
      onClick={onClick}
    >
      <span className="action-button-text">{text}</span>
    </button>
  );
};

export default ActionButton;
